export const consultingPrograms = [
  {
    months: 1,
    slug: "1-ay",
    label: "1 aylık danışmanlık",
    title: "Başlangıç ve odak",
    summary:
      "Belirli bir tema çevresinde kişisel çalışma ritmi kurmak ve yöntemi deneyimlemek isteyenler için kısa, odaklı bir çalışma alanı.",
    suitableFor:
      "Tek bir konuya odaklanmak, düzenli uygulamaya başlamak ve sürecin işleyişini görmek isteyenler.",
    focus:
      "Başlangıç anketinin değerlendirilmesi, ilk kişisel çalışmanın hazırlanması, uygulama takibi ve deneyimlerin gözden geçirilmesi.",
    difference:
      "Dört program arasındaki en kısa gözlem alanıdır. Amaç daha güçlü bir çalışma sunmak değil, belirli bir odağı sınırlı bir süre içinde izlemektir.",
  },
  {
    months: 3,
    slug: "3-ay",
    label: "3 aylık danışmanlık",
    title: "Ritim ve süreklilik",
    summary:
      "Uygulamayı günlük yaşamın içinde sürdürmek ve farklı çalışma dönemlerinin birbiriyle ilişkisini gözlemlemek isteyenler için.",
    suitableFor:
      "Tek bir başlangıç döneminin ötesinde düzenli uygulama ve birkaç değerlendirme döngüsü isteyenler.",
    focus:
      "Çalışma ritminin yerleşmesi, deneyim kayıtlarının izlenmesi ve uygun sonraki çalışmaların zaman içinde hazırlanması.",
    difference:
      "Bir aylık programa göre daha uzun bir gözlem alanı sunar; altı ve on iki aylık programlara göre kapsamı daha sınırlıdır.",
  },
  {
    months: 6,
    slug: "6-ay",
    label: "6 aylık danışmanlık",
    title: "Derinleşme ve bütünlük",
    summary:
      "Çalışmaların günlük yaşamdaki karşılığını daha uzun süre gözlemlemek ve değişen ihtiyaçlarla birlikte ilerlemek isteyenler için.",
    suitableFor:
      "Düzenli uygulamayı daha uzun bir döneme yaymak ve birden fazla çalışma evresini takip etmek isteyenler.",
    focus:
      "Deneyim birikiminin takip edilmesi, uygulama düzeninin korunması ve sonraki çalışmaların oluşan gözlemler doğrultusunda hazırlanması.",
    difference:
      "Üç aylık programa göre daha geniş bir takip süresi sunar; on iki aylık programa göre mevsimsel ve yıllık değişimleri gözlemleme alanı daha kısadır.",
  },
  {
    months: 12,
    slug: "12-ay",
    label: "12 aylık danışmanlık",
    title: "Uzun soluklu eşlik",
    summary:
      "Yılın farklı dönemlerinde oluşan deneyimleri, uygulama disiplinini ve değişen ihtiyaçları uzun bir gözlem çizgisinde takip etmek isteyenler için.",
    suitableFor:
      "Çalışmayı uzun süreli bir uygulama düzeni içinde sürdürmek ve farklı dönemleri birlikte değerlendirmek isteyenler.",
    focus:
      "Yıl boyunca kişisel çalışmaların hazırlanması, ilerlemenin izlenmesi, deneyimlerin takip edilmesi ve uygun sonraki çalışmanın belirlenmesi.",
    difference:
      "En geniş zaman ve gözlem alanını sunar. Bu, sonuç garantisi veya diğer programlardan daha güçlü olduğu anlamına gelmez.",
  },
];

export const consultingMethodSteps = [
  {
    number: "01",
    title: "Başlangıç değerlendirmesi",
    text: "Program onaylandığında başlangıç anketi açılır. Yanıtlar, kişisel çalışma planının hazırlanmasında kullanılır.",
  },
  {
    number: "02",
    title: "Kişisel çalışma",
    text: "Şeref Tolga Kuralay anketi değerlendirir ve uygulama için uygun ilk çalışmayı hazırlar.",
  },
  {
    number: "03",
    title: "Takip ve yeni yön",
    text: "Uygulama ilerlemesi panelden takip edilir. Deneyimler yazıldığında değerlendirilir ve uygun sonraki çalışma belirlenir.",
  },
];

export function getConsultingProgram(slug) {
  return consultingPrograms.find((program) => program.slug === slug) || null;
}

export function getProgramFromSearch(search) {
  const slug = new URLSearchParams(search).get("program");
  return getConsultingProgram(slug);
}
